import script from "./Expenses.vue?vue&type=script&setup=true&lang=js"
export * from "./Expenses.vue?vue&type=script&setup=true&lang=js"

import "./Expenses.vue?vue&type=style&index=0&id=4929405c&scope=true&lang=css"

const __exports__ = script;

export default __exports__